var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"border":"right","colored-border":"","type":"warning","elevation":"2","dismissible":""}},[_vm._v(" "+_vm._s(_vm.$t('LOOKS_LIKE_YOU_ARE_ON_DESKTOP_WARNING_BANNER'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }